export const IDTERMINAL = "kutxa";
export const STATIC_EVENTOS = {
  Janto_FRESH: "https://tickets.janto.es/static/eventos/",
  Janto_KB: "https://ticket.kutxabank.es/static/eventos/",
  Janto_DONAT: "https://entradas.janto.es/static/eventos/",
  Janto_4TICK: "https://www.4tickets.es/static/eventos/",
  Janto_SAB: "https://entradas.instanticket.es/static/eventos/",
  Janto_IBER: "https://compraentradas.ibercaja.es/static/eventos/",
  Janto_MG: "https://www.mgticket.com/static/eventos/",
  Janto_LBANK: "https://entradas.liberbank.es/static/eventos/",
  Janto_UNI: "https://www.unientradas.es/static/eventos/",
  Janto_DES: "http://192.168.0.7/impronta/imagenes/",
  Janto_BCJ: "http://63.34.125.18/bcj/imagenes/",
  Janto_MX: "https://janto4.mx/visitmexico/public/static/eventos/",
};

export const STATIC_RECINTOS = {
  Janto_FRESH: "https://tickets.janto.es/static/recintos/",
  Janto_KB: "https://ticket.kutxabank.es/static/recintos/",
  Janto_DONAT: "https://entradas.janto.es/static/recintos/",
  Janto_4TICK: "https://www.4tickets.es/static/recintos/",
  Janto_SAB: "https://entradas.instanticket.es/static/recintos/",
  Janto_IBER: "https://compraentradas.ibercaja.es/static/recintos/",
  Janto_MG: "https://www.mgticket.com/static/recintos/",
  Janto_LBANK: "https://entradas.liberbank.es/static/recintos/",
  Janto_UNI: "https://www.unientradas.es/static/recintos/",
  Janto_MX: "https://janto4.mx/visitmexico/public/static/recintos/",
};

export const TOMCAT = {
  Janto_MX: "http://taquillas.janto4.mx:8080/",
  Janto_SAB: "https://taquillasinstanticket.janto.es/",
  Janto_KB: "https://taquillaskb.janto.es/",
  Janto_4TICK: "https://taquillas4tick.janto.es/",
  Janto_DONAT: "https://taquillasdonat.janto.es/",
  Janto_FRESH: "https://taquillasfresh.janto.es/",
  Janto_IBERCAJA: "https://taquillasibercaja.janto.es/",
  Janto_UNI: "https://taquillasuni.janto.es/",
};

export const DEFAULT_IMG_SIZE = "poster";
